import { z } from 'zod';

const NAME_PATTERN = /^[\p{L} '.-]+$/u;
const NAME_INVALID_CHARS_ERROR = 'Incorrect format';

export const createUserSchema = z.object({
  firstName: z
    .string()
    .trim()
    .min(1, 'Required field')
    .max(50, 'Maximum 50 characters')
    .refine(val => val.length >= 2, { message: 'Minimum 2 characters' })
    .refine(val => NAME_PATTERN.test(val), {
      message: NAME_INVALID_CHARS_ERROR,
    }),
  middleName: z
    .string()
    .trim()
    .optional()
    .or(z.literal(''))
    .refine(val => !val || val.length >= 2, {
      message: 'Minimum 2 characters',
    })
    .refine(val => !val || val.length <= 50, {
      message: 'Maximum 50 characters',
    })
    .refine(val => !val || NAME_PATTERN.test(val), {
      message: NAME_INVALID_CHARS_ERROR,
    }),
  lastName: z
    .string()
    .trim()
    .min(1, 'Required field')
    .max(50, 'Maximum 50 characters')
    .refine(val => val.length >= 2, { message: 'Minimum 2 characters' })
    .refine(val => NAME_PATTERN.test(val), {
      message: NAME_INVALID_CHARS_ERROR,
    }),
  email: z
    .string()
    .trim()
    .min(1, 'Required field')
    .check(z.email({ error: 'Incorrect email format' })),
  roles: z.array(z.string()).min(1, 'Select at least one role'),
});

export const editUserSchema = z.object({
  status: z.enum(['Active', 'Inactive']),
  roles: z.array(z.string()).min(1, 'Select at least one role'),
});
